module.exports = __webpack_public_path__ + "static/media/pbb-white.9e91e1ee.svg";